import { Box, Grid } from "@material-ui/core";
import { useRef } from "react";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import ReputationProvider from "src/context/reputationContext";
import useTravaBalance from "src/hooks/useTravaBalance";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";
import ReputationRankHistory from "./ReputationRankHistory";
import ReputationSuggestions from "./ReputationSuggestions";
import StatisticalInformation from "./StatisticalInformation";
import TokenRankDetail from "./TokenRankDetail";
import TravaBalance from "./TravaBalance";
import TravaTokenOrigin from "./TravaTokenOrigin";
import YourCurrentReputation from "./YourCurrentReputation";

const ReputationLayout = () => {
  const { address } = useWeb3Connect();
  const suggestionRef = useRef(null);

  const travaBalance = useTravaBalance(address);
  let balance = travaBalance.bscTrava + travaBalance.ethTrava + travaBalance.ftmTrava;
  const isEmpty = !address || !balance || balance === 0;

  const onBuyTRAVAClick = () =>
    suggestionRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });

  return (
    <Box>
      <CommonBreadcrumb mb={1} config={[{ text: "scoring" }, { text: "reputation", link: "/reputation" }]} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} xl={6}>
          <YourCurrentReputation isEmpty={isEmpty && address} onBuyTRAVAClick={onBuyTRAVAClick} />
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <ReputationRankHistory isEmpty={isEmpty && address} onBuyTRAVAClick={onBuyTRAVAClick} />
        </Grid>
        <Grid item xs={12}>
          <TravaBalance isEmpty={isEmpty && address} onBuyTRAVAClick={onBuyTRAVAClick} />
        </Grid>
        <Grid item xs={12}>
          <TravaTokenOrigin isEmpty={isEmpty && address} onBuyTRAVAClick={onBuyTRAVAClick} />
        </Grid>
        <Grid item xs={12} ref={suggestionRef}>
          <ReputationSuggestions />
        </Grid>
        <Grid item xs={12}>
          <StatisticalInformation />
        </Grid>
        <Grid item xs={12}>
          <TokenRankDetail />
        </Grid>
      </Grid>
    </Box>
  );
};

export default function Reputation() {
  return (
    <ReputationProvider>
      <ReputationLayout />
    </ReputationProvider>
  );
}
